import { authenticateUser } from '../contexts';

import { AuthError } from './errors';

interface AuthHeaders {
  [key: string]: unknown;
}

export const authRedirectCheck = async <T extends { headers: AuthHeaders }>(
  config: T,
): Promise<T> => {
  const user = await authenticateUser();

  if (!user.apiKey || !user.accessKey || !user.authProvider) {
    return Promise.reject(new AuthError());
  }

  config.headers['Authorization'] = `Bearer ${user.apiKey}`;
  config.headers['x-api-key'] = user.apiKey;
  config.headers['x-api-access-key'] = user.accessKey;
  config.headers['x-auth-provider'] = user.authProvider;

  return config;
};

export const authRedirectCheckRtkQuery = async () => {
  const user = await authenticateUser();
  if (!user.apiKey || !user.accessKey || !user.authProvider) {
    return {
      idToken: undefined,
      accessToken: undefined,
      authProvider: undefined,
    };
  }

  return {
    idToken: user.apiKey,
    accessToken: user.accessKey,
    authProvider: user.authProvider,
  };
};
